// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Generic from "../Data.Argonaut.Decode.Generic/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Argonaut_Encode_Generic from "../Data.Argonaut.Encode.Generic/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_TransmissionStats from "../Data.TransmissionStats/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Vector2 from "../Data.Vector2/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_FSError from "../Fusion.Data.FSError/index.js";
import * as Fusion_Data_FSValue from "../Fusion.Data.FSValue/index.js";
import * as Fusion_Data_FSWarning from "../Fusion.Data.FSWarning/index.js";
import * as Fusion_Data_Measurement from "../Fusion.Data.Measurement/index.js";
import * as Fusion_Data_Speed from "../Fusion.Data.Speed/index.js";
import * as Fusion_Data_Timestamp from "../Fusion.Data.Timestamp/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as MST_Data_EngineCommunication from "../MST.Data.EngineCommunication/index.js";
import * as MST_Encoding from "../MST.Encoding/index.js";
import * as Record from "../Record/index.js";
import * as Visonum_Cross_Components_App_Types_Page from "../Visonum.Cross.Components.App.Types.Page/index.js";
import * as Visonum_Cross_Data_Pixel from "../Visonum.Cross.Data.Pixel/index.js";
import * as Visonum_Cross_Extra_Lenses from "../Visonum.Cross.Extra.Lenses/index.js";
import * as Visonum_Cross_Types_Brand from "../Visonum.Cross.Types.Brand/index.js";
import * as Visonum_Cross_Types_UserConsent from "../Visonum.Cross.Types.UserConsent/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var AutoScrollIsSymbol = {
    reflectSymbol: function () {
        return "AutoScroll";
    }
};
var ManualScrollIsSymbol = {
    reflectSymbol: function () {
        return "ManualScroll";
    }
};
var ExpertModeIsSymbol = {
    reflectSymbol: function () {
        return "ExpertMode";
    }
};
var NormalModeIsSymbol = {
    reflectSymbol: function () {
        return "NormalMode";
    }
};
var AfterConsentSpeedtestIsSymbol = {
    reflectSymbol: function () {
        return "AfterConsentSpeedtest";
    }
};
var AfterConsentSettingsIsSymbol = {
    reflectSymbol: function () {
        return "AfterConsentSettings";
    }
};
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Visonum_Cross_Types_Brand.encodeJsonBrand));
var gEncodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJBoolean);
var gEncodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Fusion_Data_Duration.encodeJsonDuration));
var gEncodeJsonCons3 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Fusion_Data_Speed.encodeJsonSpeed));
var uploadDurationMillisIsSymbol = {
    reflectSymbol: function () {
        return "uploadDurationMillis";
    }
};
var serverlessIsSymbol = {
    reflectSymbol: function () {
        return "serverless";
    }
};
var preserveStateIsSymbol = {
    reflectSymbol: function () {
        return "preserveState";
    }
};
var pingDurationMillisIsSymbol = {
    reflectSymbol: function () {
        return "pingDurationMillis";
    }
};
var pageIsSymbol = {
    reflectSymbol: function () {
        return "page";
    }
};
var maxUploadBookedSpeedIsSymbol = {
    reflectSymbol: function () {
        return "maxUploadBookedSpeed";
    }
};
var maxDownloadBookedSpeedIsSymbol = {
    reflectSymbol: function () {
        return "maxDownloadBookedSpeed";
    }
};
var downloadDurationMillisIsSymbol = {
    reflectSymbol: function () {
        return "downloadDurationMillis";
    }
};
var debugIsSymbol = {
    reflectSymbol: function () {
        return "debug";
    }
};
var brandIsSymbol = {
    reflectSymbol: function () {
        return "brand";
    }
};
var gEncodeJsonCons4 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Fusion_Data_Timestamp.encodeJsonTimestamp))(Data_Argonaut_Encode_Class.gEncodeJsonNil);
var timestampIsSymbol = {
    reflectSymbol: function () {
        return "timestamp";
    }
};
var termsAndConditionsIsSymbol = {
    reflectSymbol: function () {
        return "termsAndConditions";
    }
};
var bugReportsIsSymbol = {
    reflectSymbol: function () {
        return "bugReports";
    }
};
var analyticsIsSymbol = {
    reflectSymbol: function () {
        return "analytics";
    }
};
var gEncodeJsonCons5 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt);
var gEncodeJsonCons6 = /* #__PURE__ */ gEncodeJsonCons5(Data_Argonaut_Encode_Class.gEncodeJsonNil);
var selectedSpeedtestRouteIndexIsSymbol = {
    reflectSymbol: function () {
        return "selectedSpeedtestRouteIndex";
    }
};
var rapidPingResultIsSymbol = {
    reflectSymbol: function () {
        return "rapidPingResult";
    }
};
var gEncodeJsonCons7 = /* #__PURE__ */ gEncodeJsonCons1(Data_Argonaut_Encode_Class.gEncodeJsonNil);
var showWarningsIsSymbol = {
    reflectSymbol: function () {
        return "showWarnings";
    }
};
var selectedTabIsSymbol = {
    reflectSymbol: function () {
        return "selectedTab";
    }
};
var gEncodeJsonCons8 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJString);
var useLocalEngineIsSymbol = {
    reflectSymbol: function () {
        return "useLocalEngine";
    }
};
var titleIsSymbol = {
    reflectSymbol: function () {
        return "title";
    }
};
var iconSourceIsSymbol = {
    reflectSymbol: function () {
        return "iconSource";
    }
};
var iconDestinationIsSymbol = {
    reflectSymbol: function () {
        return "iconDestination";
    }
};
var fieldStreamCountUploadIsSymbol = {
    reflectSymbol: function () {
        return "fieldStreamCountUpload";
    }
};
var fieldStreamCountDownloadIsSymbol = {
    reflectSymbol: function () {
        return "fieldStreamCountDownload";
    }
};
var fieldEngineUrlIsSymbol = {
    reflectSymbol: function () {
        return "fieldEngineUrl";
    }
};
var fieldDestinationUrlsIsSymbol = {
    reflectSymbol: function () {
        return "fieldDestinationUrls";
    }
};
var checkResultIsSymbol = {
    reflectSymbol: function () {
        return "checkResult";
    }
};
var speedtestRoutesIsSymbol = {
    reflectSymbol: function () {
        return "speedtestRoutes";
    }
};
var gEncodeJsonCons9 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Speed.encodeJsonSpeed);
var gEncodeJsonCons10 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Timestamp.encodeJsonTimestamp);
var gEncodeJsonCons11 = /* #__PURE__ */ gEncodeJsonCons10(Data_Argonaut_Encode_Class.gEncodeJsonNil)(timestampIsSymbol)();
var speedIsSymbol = {
    reflectSymbol: function () {
        return "speed";
    }
};
var encodeRecord = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons9(gEncodeJsonCons11)(speedIsSymbol)())();
var encodeJsonArray = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(encodeRecord);
var gEncodeJsonCons12 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeJsonArray);
var totalSpeedIsSymbol = {
    reflectSymbol: function () {
        return "totalSpeed";
    }
};
var streamSpeedsIsSymbol = {
    reflectSymbol: function () {
        return "streamSpeeds";
    }
};
var bytesIsSymbol = {
    reflectSymbol: function () {
        return "bytes";
    }
};
var gEncodeJsonCons13 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_TransmissionStats.encodeJsonTransmissionSta);
var statsPassiveIsSymbol = {
    reflectSymbol: function () {
        return "statsPassive";
    }
};
var statsActiveIsSymbol = {
    reflectSymbol: function () {
        return "statsActive";
    }
};
var jitterIsSymbol = {
    reflectSymbol: function () {
        return "jitter";
    }
};
var gEncodeJsonCons14 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(Data_TransmissionStats.encodeJsonTransmissionSta));
var warningIsSymbol = {
    reflectSymbol: function () {
        return "warning";
    }
};
var streamIndexIsSymbol = {
    reflectSymbol: function () {
        return "streamIndex";
    }
};
var warningsIsSymbol = {
    reflectSymbol: function () {
        return "warnings";
    }
};
var statIntermediatesPassiveIsSymbol = {
    reflectSymbol: function () {
        return "statIntermediatesPassive";
    }
};
var statIntermediatesActiveIsSymbol = {
    reflectSymbol: function () {
        return "statIntermediatesActive";
    }
};
var runningIsSymbol = {
    reflectSymbol: function () {
        return "running";
    }
};
var intermediatesIsSymbol = {
    reflectSymbol: function () {
        return "intermediates";
    }
};
var finalIsSymbol = {
    reflectSymbol: function () {
        return "final";
    }
};
var currentIsSymbol = {
    reflectSymbol: function () {
        return "current";
    }
};
var gEncodeJsonCons15 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Bytes.encodeJsonBytes)(/* #__PURE__ */ gEncodeJsonCons12(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeRecord)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(totalSpeedIsSymbol)())(streamSpeedsIsSymbol)())(bytesIsSymbol)())()))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons9(/* #__PURE__ */ gEncodeJsonCons9(/* #__PURE__ */ gEncodeJsonCons13(/* #__PURE__ */ gEncodeJsonCons13(Data_Argonaut_Encode_Class.gEncodeJsonNil)(statsPassiveIsSymbol)())(statsActiveIsSymbol)())(speedIsSymbol)())(jitterIsSymbol)())()))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeMap(Data_Ord.ordInt)(Data_Argonaut_Encode_Class.encodeJsonInt)(encodeJsonArray))(/* #__PURE__ */ gEncodeJsonCons12(Data_Argonaut_Encode_Class.gEncodeJsonNil)(totalSpeedIsSymbol)())(streamSpeedsIsSymbol)())())(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons14(/* #__PURE__ */ gEncodeJsonCons14(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ gEncodeJsonCons10(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_FSWarning.encodeJsonFSWarning)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(warningIsSymbol)())(timestampIsSymbol)())(streamIndexIsSymbol)())()))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(warningsIsSymbol)())(statIntermediatesPassiveIsSymbol)())(statIntermediatesActiveIsSymbol)())(runningIsSymbol)())(intermediatesIsSymbol)())(finalIsSymbol)())(currentIsSymbol)())());
var gEncodeJsonCons16 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Duration.encodeJsonDuration);
var minimumIsSymbol = {
    reflectSymbol: function () {
        return "minimum";
    }
};
var medianIsSymbol = {
    reflectSymbol: function () {
        return "median";
    }
};
var countIsSymbol = {
    reflectSymbol: function () {
        return "count";
    }
};
var averageIsSymbol = {
    reflectSymbol: function () {
        return "average";
    }
};
var pingTimeIsSymbol = {
    reflectSymbol: function () {
        return "pingTime";
    }
};
var maxUploadProvisionedSpeedIsSymbol = {
    reflectSymbol: function () {
        return "maxUploadProvisionedSpeed";
    }
};
var maxDownloadProvisionedSpeedIsSymbol = {
    reflectSymbol: function () {
        return "maxDownloadProvisionedSpeed";
    }
};
var gEncodeJsonCons17 = /* #__PURE__ */ gEncodeJsonCons8(Data_Argonaut_Encode_Class.gEncodeJsonNil);
var speedtestIDIsSymbol = {
    reflectSymbol: function () {
        return "speedtestID";
    }
};
var contractInfoIsSymbol = {
    reflectSymbol: function () {
        return "contractInfo";
    }
};
var gEncodeJsonCons18 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonJString))(Data_Argonaut_Encode_Class.gEncodeJsonNil);
var userAgentIsSymbol = {
    reflectSymbol: function () {
        return "userAgent";
    }
};
var ispIsSymbol = {
    reflectSymbol: function () {
        return "isp";
    }
};
var ipVersionIsSymbol = {
    reflectSymbol: function () {
        return "ipVersion";
    }
};
var ipIsSymbol = {
    reflectSymbol: function () {
        return "ip";
    }
};
var connectionIsSymbol = {
    reflectSymbol: function () {
        return "connection";
    }
};
var clientIsSymbol = {
    reflectSymbol: function () {
        return "client";
    }
};
var gEncodeJsonCons19 = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(MST_Data_BasicURL.encodeJsonBasicURL));
var statsIsSymbol = {
    reflectSymbol: function () {
        return "stats";
    }
};
var progressIsSymbol = {
    reflectSymbol: function () {
        return "progress";
    }
};
var loadIsSymbol = {
    reflectSymbol: function () {
        return "load";
    }
};
var encodeRecord1 = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(MST_Data_BasicURL.encodeJsonBasicURL)(/* #__PURE__ */ gEncodeJsonCons19(/* #__PURE__ */ gEncodeJsonCons19(Data_Argonaut_Encode_Class.gEncodeJsonNil)(statsIsSymbol)())(progressIsSymbol)())(loadIsSymbol)())();
var numStreamsIsSymbol = {
    reflectSymbol: function () {
        return "numStreams";
    }
};
var durationIsSymbol = {
    reflectSymbol: function () {
        return "duration";
    }
};
var downloadAddressesIsSymbol = {
    reflectSymbol: function () {
        return "downloadAddresses";
    }
};
var uploadAddressIsSymbol = {
    reflectSymbol: function () {
        return "uploadAddress";
    }
};
var uploadIsSymbol = {
    reflectSymbol: function () {
        return "upload";
    }
};
var downloadIsSymbol = {
    reflectSymbol: function () {
        return "download";
    }
};
var stepDetailsIsSymbol = {
    reflectSymbol: function () {
        return "stepDetails";
    }
};
var initIsSymbol = {
    reflectSymbol: function () {
        return "init";
    }
};
var infoIsSymbol = {
    reflectSymbol: function () {
        return "info";
    }
};
var numUploadStreamsIsSymbol = {
    reflectSymbol: function () {
        return "numUploadStreams";
    }
};
var numDownloadStreamsIsSymbol = {
    reflectSymbol: function () {
        return "numDownloadStreams";
    }
};
var engineTypeIsSymbol = {
    reflectSymbol: function () {
        return "engineType";
    }
};
var destinationsIsSymbol = {
    reflectSymbol: function () {
        return "destinations";
    }
};
var speedtestRouteIsSymbol = {
    reflectSymbol: function () {
        return "speedtestRoute";
    }
};
var prepareIsSymbol = {
    reflectSymbol: function () {
        return "prepare";
    }
};
var pingIsSymbol = {
    reflectSymbol: function () {
        return "ping";
    }
};
var errorIsSymbol = {
    reflectSymbol: function () {
        return "error";
    }
};
var speedtestStartedIsSymbol = {
    reflectSymbol: function () {
        return "speedtestStarted";
    }
};
var speedtestResultIsSymbol = {
    reflectSymbol: function () {
        return "speedtestResult";
    }
};
var scrollModeIsSymbol = {
    reflectSymbol: function () {
        return "scrollMode";
    }
};
var pageSettingsIsSymbol = {
    reflectSymbol: function () {
        return "pageSettings";
    }
};
var pageMeasureResultIsSymbol = {
    reflectSymbol: function () {
        return "pageMeasureResult";
    }
};
var pageDashboardIsSymbol = {
    reflectSymbol: function () {
        return "pageDashboard";
    }
};
var consentIsSymbol = {
    reflectSymbol: function () {
        return "consent";
    }
};
var commonQueryIsSymbol = {
    reflectSymbol: function () {
        return "commonQuery";
    }
};
var appSizeIsSymbol = {
    reflectSymbol: function () {
        return "appSize";
    }
};
var appModeIsSymbol = {
    reflectSymbol: function () {
        return "appMode";
    }
};
var afterConsentIsSymbol = {
    reflectSymbol: function () {
        return "afterConsent";
    }
};
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Visonum_Cross_Types_Brand.decodeJsonBrand));
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean));
var gDecodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Fusion_Data_Duration.decodeJsonDuration));
var gDecodeJsonCons3 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Fusion_Data_Speed.decodeJsonSpeed));
var gDecodeJsonCons4 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Fusion_Data_Timestamp.decodeJsonTimestamp))(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var gDecodeJsonCons5 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt));
var gDecodeJsonCons6 = /* #__PURE__ */ gDecodeJsonCons5(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var gDecodeJsonCons7 = /* #__PURE__ */ gDecodeJsonCons1(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var gDecodeJsonCons8 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons9 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Speed.decodeJsonSpeed));
var gDecodeJsonCons10 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Timestamp.decodeJsonTimestamp));
var gDecodeJsonCons11 = /* #__PURE__ */ gDecodeJsonCons10(Data_Argonaut_Decode_Class.gDecodeJsonNil)(timestampIsSymbol)()();
var decodeRecord = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons9(gDecodeJsonCons11)(speedIsSymbol)()())();
var decodeArray = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(decodeRecord);
var gDecodeJsonCons12 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decodeArray));
var gDecodeJsonCons13 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_TransmissionStats.decodeJsonTransmissionSta));
var gDecodeJsonCons14 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(Data_TransmissionStats.decodeJsonTransmissionSta)));
var gDecodeJsonCons15 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Bytes.decodeJsonBytes))(/* #__PURE__ */ gDecodeJsonCons12(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decodeRecord))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(totalSpeedIsSymbol)()())(streamSpeedsIsSymbol)()())(bytesIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ gDecodeJsonCons13(/* #__PURE__ */ gDecodeJsonCons13(Data_Argonaut_Decode_Class.gDecodeJsonNil)(statsPassiveIsSymbol)()())(statsActiveIsSymbol)()())(speedIsSymbol)()())(jitterIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeMap(Data_Ord.ordInt)(Data_Argonaut_Decode_Class.decodeJsonInt)(decodeArray)))(/* #__PURE__ */ gDecodeJsonCons12(Data_Argonaut_Decode_Class.gDecodeJsonNil)(totalSpeedIsSymbol)()())(streamSpeedsIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons14(/* #__PURE__ */ gDecodeJsonCons14(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons5(/* #__PURE__ */ gDecodeJsonCons10(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_FSWarning.decodeJsonFSWarning))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(warningIsSymbol)()())(timestampIsSymbol)()())(streamIndexIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(warningsIsSymbol)()())(statIntermediatesPassiveIsSymbol)()())(statIntermediatesActiveIsSymbol)()())(runningIsSymbol)()())(intermediatesIsSymbol)()())(finalIsSymbol)()())(currentIsSymbol)()())()));
var gDecodeJsonCons16 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Duration.decodeJsonDuration));
var gDecodeJsonCons17 = /* #__PURE__ */ gDecodeJsonCons8(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var gDecodeJsonCons18 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonString))(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var gDecodeJsonCons19 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(MST_Data_BasicURL.decodeJsonBasicURL));
var decodeRecord1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(MST_Data_BasicURL.decodeJsonBasicURL))(/* #__PURE__ */ gDecodeJsonCons19(/* #__PURE__ */ gDecodeJsonCons19(Data_Argonaut_Decode_Class.gDecodeJsonNil)(statsIsSymbol)()())(progressIsSymbol)()())(loadIsSymbol)()())();
var merge = /* #__PURE__ */ Record.merge()();
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var eqRec = /* #__PURE__ */ Data_Eq.eqRec();
var eqRowCons = /* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(timestampIsSymbol)(Fusion_Data_Timestamp.eqTimestamp))();
var notEq = /* #__PURE__ */ Data_Eq.notEq(/* #__PURE__ */ Data_Eq.eqArray(/* #__PURE__ */ eqRec(/* #__PURE__ */ eqRowCons(speedIsSymbol)(Fusion_Data_Speed.eqSpeed))));
var notEq1 = /* #__PURE__ */ Data_Eq.notEq(/* #__PURE__ */ Data_Eq.eqArray(/* #__PURE__ */ eqRec(/* #__PURE__ */ eqRowCons(pingTimeIsSymbol)(Fusion_Data_Duration.eqDuration))));
var and = /* #__PURE__ */ Data_Foldable.and(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean);
var zero = /* #__PURE__ */ Data_Semiring.zero(/* #__PURE__ */ Data_Vector2.semiringVec(Visonum_Cross_Data_Pixel.semiringPixel));
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Control_Applicative.applicativeArray);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Maybe.functorMaybe);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var heytingAlgebraFunction = /* #__PURE__ */ Data_HeytingAlgebra.heytingAlgebraFunction(Data_HeytingAlgebra.heytingAlgebraBoolean);
var not = /* #__PURE__ */ Data_HeytingAlgebra.not(heytingAlgebraFunction);
var apply = /* #__PURE__ */ Control_Apply.apply(Data_Maybe.applyMaybe);
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var mod = /* #__PURE__ */ Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var toUnfoldable = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var minimum = /* #__PURE__ */ Data_Foldable.minimum(Fusion_Data_Timestamp.ordTimestamp)(Data_Foldable.foldableArray);
var maximum = /* #__PURE__ */ Data_Foldable.maximum(Fusion_Data_Timestamp.ordTimestamp)(Data_Foldable.foldableArray);
var disj = /* #__PURE__ */ Data_HeytingAlgebra.disj(heytingAlgebraFunction);
var prop = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "internal";
    }
})()();
var prop1 = /* #__PURE__ */ Visonum_Cross_Extra_Lenses.prop({
    reflectSymbol: function () {
        return "app";
    }
})()();
var VecJ = function (x) {
    return x;
};
var AutoScroll = /* #__PURE__ */ (function () {
    function AutoScroll() {

    };
    AutoScroll.value = new AutoScroll();
    return AutoScroll;
})();
var ManualScroll = /* #__PURE__ */ (function () {
    function ManualScroll() {

    };
    ManualScroll.value = new ManualScroll();
    return ManualScroll;
})();
var ExpertMode = /* #__PURE__ */ (function () {
    function ExpertMode() {

    };
    ExpertMode.value = new ExpertMode();
    return ExpertMode;
})();
var NormalMode = /* #__PURE__ */ (function () {
    function NormalMode() {

    };
    NormalMode.value = new NormalMode();
    return NormalMode;
})();
var AfterConsentSpeedtest = /* #__PURE__ */ (function () {
    function AfterConsentSpeedtest() {

    };
    AfterConsentSpeedtest.value = new AfterConsentSpeedtest();
    return AfterConsentSpeedtest;
})();
var AfterConsentSettings = /* #__PURE__ */ (function () {
    function AfterConsentSettings() {

    };
    AfterConsentSettings.value = new AfterConsentSettings();
    return AfterConsentSettings;
})();
var AppStateJ = function (x) {
    return x;
};
var newtypeVecJ_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeAppStateJ_ = {
    Coercible0: function () {
        return undefined;
    }
};
var genericScrollMode_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return AutoScroll.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return ManualScroll.value;
        };
        throw new Error("Failed pattern match at Visonum.Cross.Components.App.Types.AppState (line 465, column 1 - line 465, column 37): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof AutoScroll) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof ManualScroll) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Visonum.Cross.Components.App.Types.AppState (line 465, column 1 - line 465, column 37): " + [ x.constructor.name ]);
    }
};
var showScrollMode = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericScrollMode_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(AutoScrollIsSymbol))(/* #__PURE__ */ genericShowConstructor(ManualScrollIsSymbol)))
};
var genericAppMode_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return ExpertMode.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return NormalMode.value;
        };
        throw new Error("Failed pattern match at Visonum.Cross.Components.App.Types.AppState (line 450, column 1 - line 450, column 34): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ExpertMode) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof NormalMode) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Visonum.Cross.Components.App.Types.AppState (line 450, column 1 - line 450, column 34): " + [ x.constructor.name ]);
    }
};
var showAppMode = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericAppMode_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ExpertModeIsSymbol))(/* #__PURE__ */ genericShowConstructor(NormalModeIsSymbol)))
};
var genericAfterConsent_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return AfterConsentSpeedtest.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return AfterConsentSettings.value;
        };
        throw new Error("Failed pattern match at Visonum.Cross.Components.App.Types.AppState (line 527, column 1 - line 527, column 39): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof AfterConsentSpeedtest) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof AfterConsentSettings) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Visonum.Cross.Components.App.Types.AppState (line 527, column 1 - line 527, column 39): " + [ x.constructor.name ]);
    }
};
var showAfterConsent = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericAfterConsent_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(AfterConsentSpeedtestIsSymbol))(/* #__PURE__ */ genericShowConstructor(AfterConsentSettingsIsSymbol)))
};
var eqAppMode = {
    eq: function (x) {
        return function (y) {
            if (x instanceof ExpertMode && y instanceof ExpertMode) {
                return true;
            };
            if (x instanceof NormalMode && y instanceof NormalMode) {
                return true;
            };
            return false;
        };
    }
};
var eqAfterConsent = {
    eq: function (x) {
        return function (y) {
            if (x instanceof AfterConsentSpeedtest && y instanceof AfterConsentSpeedtest) {
                return true;
            };
            if (x instanceof AfterConsentSettings && y instanceof AfterConsentSettings) {
                return true;
            };
            return false;
        };
    }
};
var encodeJsonVecJ = function (dictEncodeJson) {
    var encodeJson1 = Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonTuple(dictEncodeJson)(dictEncodeJson));
    return {
        encodeJson: function (v) {
            return encodeJson1(new Data_Tuple.Tuple(v.value0, v.value1));
        }
    };
};
var encodeJsonScrollMode = {
    encodeJson: /* #__PURE__ */ MST_Encoding.genericEncodeJsonVisonum(genericScrollMode_)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(AutoScrollIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(ManualScrollIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments)))
};
var encodeJsonAppMode = {
    encodeJson: /* #__PURE__ */ Data_Argonaut_Encode_Generic.genericEncodeJson(genericAppMode_)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(ExpertModeIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(NormalModeIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments)))
};
var encodeJsonAfterConsent = {
    encodeJson: /* #__PURE__ */ Data_Argonaut_Encode_Generic.genericEncodeJson(genericAfterConsent_)(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepSum(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(AfterConsentSpeedtestIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments))(/* #__PURE__ */ Data_Argonaut_Encode_Generic.encodeRepConstructor(AfterConsentSettingsIsSymbol)(Data_Argonaut_Encode_Generic.encodeRepArgsNoArguments)))
};
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeJsonAfterConsent)(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeJsonAppMode)(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ encodeJsonVecJ(Visonum_Cross_Data_Pixel.encodeJsonPixel))(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons2(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Visonum_Cross_Components_App_Types_Page.encodeJsonPage))(/* #__PURE__ */ gEncodeJsonCons2(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons2(Data_Argonaut_Encode_Class.gEncodeJsonNil)(uploadDurationMillisIsSymbol)())(serverlessIsSymbol)())(preserveStateIsSymbol)())(pingDurationMillisIsSymbol)())(pageIsSymbol)())(maxUploadBookedSpeedIsSymbol)())(maxDownloadBookedSpeedIsSymbol)())(downloadDurationMillisIsSymbol)())(debugIsSymbol)())(brandIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons1(/* #__PURE__ */ gEncodeJsonCons4(timestampIsSymbol)())(termsAndConditionsIsSymbol)())(bugReportsIsSymbol)())(analyticsIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Visonum_Cross_Components_App_Types_Page.encodeJsonPage)(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons2(/* #__PURE__ */ gEncodeJsonCons6(selectedSpeedtestRouteIndexIsSymbol)())(rapidPingResultIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_Measurement.encodeJsonMeasurement)(/* #__PURE__ */ gEncodeJsonCons7(showWarningsIsSymbol)())(selectedTabIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonNonEmptyArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Data_Argonaut_Encode_Class.encodeJsonJBoolean))(/* #__PURE__ */ gEncodeJsonCons8(/* #__PURE__ */ gEncodeJsonCons8(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ gEncodeJsonCons8(/* #__PURE__ */ gEncodeJsonCons8(/* #__PURE__ */ gEncodeJsonCons8(/* #__PURE__ */ gEncodeJsonCons7(useLocalEngineIsSymbol)())(titleIsSymbol)())(iconSourceIsSymbol)())(iconDestinationIsSymbol)())(fieldStreamCountUploadIsSymbol)())(fieldStreamCountDownloadIsSymbol)())(fieldEngineUrlIsSymbol)())(fieldDestinationUrlsIsSymbol)())(checkResultIsSymbol)())()))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(speedtestRoutesIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeJsonScrollMode)(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons15(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(Fusion_Data_FSError.encodeJsonFSError))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons16(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ gEncodeJsonCons16(/* #__PURE__ */ gEncodeJsonCons16(/* #__PURE__ */ gEncodeJsonCons16(Data_Argonaut_Encode_Class.gEncodeJsonNil)(minimumIsSymbol)())(medianIsSymbol)())(jitterIsSymbol)())(countIsSymbol)())(averageIsSymbol)())()))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons16(gEncodeJsonCons11)(pingTimeIsSymbol)())()))(/* #__PURE__ */ gEncodeJsonCons7(runningIsSymbol)())(intermediatesIsSymbol)())(finalIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons3(/* #__PURE__ */ gEncodeJsonCons3(Data_Argonaut_Encode_Class.gEncodeJsonNil)(maxUploadProvisionedSpeedIsSymbol)())(maxUploadBookedSpeedIsSymbol)())(maxDownloadProvisionedSpeedIsSymbol)())(maxDownloadBookedSpeedIsSymbol)())())(/* #__PURE__ */ gEncodeJsonCons17(speedtestIDIsSymbol)())(contractInfoIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons18(userAgentIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons8(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Fusion_Data_FSValue.encodeJsonIpVersion)(/* #__PURE__ */ gEncodeJsonCons18(ispIsSymbol)())(ipVersionIsSymbol)())(ipIsSymbol)())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(connectionIsSymbol)())(clientIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonNonEmptyArray(encodeRecord1))(/* #__PURE__ */ gEncodeJsonCons16(/* #__PURE__ */ gEncodeJsonCons6(numStreamsIsSymbol)())(durationIsSymbol)())(downloadAddressesIsSymbol)())())(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons16(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encodeRecord1)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(uploadAddressIsSymbol)())(numStreamsIsSymbol)())(durationIsSymbol)())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(uploadIsSymbol)())(downloadIsSymbol)())())(Data_Argonaut_Encode_Class.gEncodeJsonNil)(stepDetailsIsSymbol)())(initIsSymbol)())(infoIsSymbol)())()))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonMaybe(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonNonEmptyArray(MST_Data_BasicURL.encodeJsonBasicURL))(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(MST_Data_EngineCommunication.encodeJsonEngineType)(/* #__PURE__ */ gEncodeJsonCons8(/* #__PURE__ */ gEncodeJsonCons8(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ gEncodeJsonCons5(/* #__PURE__ */ gEncodeJsonCons17(titleIsSymbol)())(numUploadStreamsIsSymbol)())(numDownloadStreamsIsSymbol)())(iconSourceIsSymbol)())(iconDestinationIsSymbol)())(engineTypeIsSymbol)())(destinationsIsSymbol)())()))(/* #__PURE__ */ gEncodeJsonCons15(Data_Argonaut_Encode_Class.gEncodeJsonNil)(uploadIsSymbol)())(speedtestRouteIsSymbol)())(prepareIsSymbol)())(pingIsSymbol)())(errorIsSymbol)())(downloadIsSymbol)())())(/* #__PURE__ */ gEncodeJsonCons4(speedtestStartedIsSymbol)())(speedtestResultIsSymbol)())(scrollModeIsSymbol)())(pageSettingsIsSymbol)())(pageMeasureResultIsSymbol)())(pageDashboardIsSymbol)())(pageIsSymbol)())(consentIsSymbol)())(commonQueryIsSymbol)())(brandIsSymbol)())(appSizeIsSymbol)())(appModeIsSymbol)())(afterConsentIsSymbol)())());
var encodeJsonAppStateJ = {
    encodeJson: function (v) {
        var val = {
            afterConsent: v.afterConsent,
            appMode: v.appMode,
            brand: v.brand,
            commonQuery: v.commonQuery,
            consent: v.consent,
            page: v.page,
            pageDashboard: v.pageDashboard,
            pageMeasureResult: v.pageMeasureResult,
            pageSettings: v.pageSettings,
            scrollMode: v.scrollMode,
            speedtestResult: v.speedtestResult,
            speedtestStarted: v.speedtestStarted,
            appSize: v.appSize
        };
        return encodeJson(val);
    }
};
var decodeJsonVecJ = function (dictDecodeJson) {
    var decodeJson2 = Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeJsonTuple(dictDecodeJson)(dictDecodeJson));
    return {
        decodeJson: function (json) {
            return bind(decodeJson2(json))(function (v) {
                return pure(new Data_Vector2.Vec(v.value0, v.value1));
            });
        }
    };
};
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ decodeJsonVecJ(Visonum_Cross_Data_Pixel.decodeJsonPixel)))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(appSizeIsSymbol)()())());
var decodeJsonScrollMode = {
    decodeJson: /* #__PURE__ */ MST_Encoding.genericDecodeJsonVisonum(genericScrollMode_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(AutoScrollIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(ManualScrollIsSymbol)))
};
var decodeJsonAppMode = {
    decodeJson: /* #__PURE__ */ Data_Argonaut_Decode_Generic.genericDecodeJson(genericAppMode_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(ExpertModeIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(NormalModeIsSymbol)))
};
var decodeJsonAfterConsent = {
    decodeJson: /* #__PURE__ */ Data_Argonaut_Decode_Generic.genericDecodeJson(genericAfterConsent_)(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepSum(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(AfterConsentSpeedtestIsSymbol))(/* #__PURE__ */ Data_Argonaut_Decode_Generic.decodeRepConstructorNoArgs(AfterConsentSettingsIsSymbol)))
};
var decodeJson1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decodeJsonAfterConsent))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decodeJsonAppMode))(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Visonum_Cross_Components_App_Types_Page.decodeJsonPage))(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons2(Data_Argonaut_Decode_Class.gDecodeJsonNil)(uploadDurationMillisIsSymbol)()())(serverlessIsSymbol)()())(preserveStateIsSymbol)()())(pingDurationMillisIsSymbol)()())(pageIsSymbol)()())(maxUploadBookedSpeedIsSymbol)()())(maxDownloadBookedSpeedIsSymbol)()())(downloadDurationMillisIsSymbol)()())(debugIsSymbol)()())(brandIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons4(timestampIsSymbol)()())(termsAndConditionsIsSymbol)()())(bugReportsIsSymbol)()())(analyticsIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Visonum_Cross_Components_App_Types_Page.decodeJsonPage))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons6(selectedSpeedtestRouteIndexIsSymbol)()())(rapidPingResultIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_Measurement.decodeJsonMeasurement))(/* #__PURE__ */ gDecodeJsonCons7(showWarningsIsSymbol)()())(selectedTabIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJsonNonEmptyArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonBoolean))(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ gDecodeJsonCons5(/* #__PURE__ */ gDecodeJsonCons5(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ gDecodeJsonCons7(useLocalEngineIsSymbol)()())(titleIsSymbol)()())(iconSourceIsSymbol)()())(iconDestinationIsSymbol)()())(fieldStreamCountUploadIsSymbol)()())(fieldStreamCountDownloadIsSymbol)()())(fieldEngineUrlIsSymbol)()())(fieldDestinationUrlsIsSymbol)()())(checkResultIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(speedtestRoutesIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decodeJsonScrollMode))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons15(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Fusion_Data_FSError.decodeJsonFSError))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons16(/* #__PURE__ */ gDecodeJsonCons5(/* #__PURE__ */ gDecodeJsonCons16(/* #__PURE__ */ gDecodeJsonCons16(/* #__PURE__ */ gDecodeJsonCons16(Data_Argonaut_Decode_Class.gDecodeJsonNil)(minimumIsSymbol)()())(medianIsSymbol)()())(jitterIsSymbol)()())(countIsSymbol)()())(averageIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons16(gDecodeJsonCons11)(pingTimeIsSymbol)()())())))(/* #__PURE__ */ gDecodeJsonCons7(runningIsSymbol)()())(intermediatesIsSymbol)()())(finalIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons3(Data_Argonaut_Decode_Class.gDecodeJsonNil)(maxUploadProvisionedSpeedIsSymbol)()())(maxUploadBookedSpeedIsSymbol)()())(maxDownloadProvisionedSpeedIsSymbol)()())(maxDownloadBookedSpeedIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons17(speedtestIDIsSymbol)()())(contractInfoIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons18(userAgentIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Fusion_Data_FSValue.decodeJsonIpVersion))(/* #__PURE__ */ gDecodeJsonCons18(ispIsSymbol)()())(ipVersionIsSymbol)()())(ipIsSymbol)()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(connectionIsSymbol)()())(clientIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJsonNonEmptyArray(decodeRecord1)))(/* #__PURE__ */ gDecodeJsonCons16(/* #__PURE__ */ gDecodeJsonCons6(numStreamsIsSymbol)()())(durationIsSymbol)()())(downloadAddressesIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons16(/* #__PURE__ */ gDecodeJsonCons5(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decodeRecord1))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(uploadAddressIsSymbol)()())(numStreamsIsSymbol)()())(durationIsSymbol)()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(uploadIsSymbol)()())(downloadIsSymbol)()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(stepDetailsIsSymbol)()())(initIsSymbol)()())(infoIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJsonNonEmptyArray(MST_Data_BasicURL.decodeJsonBasicURL)))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(MST_Data_EngineCommunication.decodeJsonEngineType))(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ gDecodeJsonCons5(/* #__PURE__ */ gDecodeJsonCons5(/* #__PURE__ */ gDecodeJsonCons17(titleIsSymbol)()())(numUploadStreamsIsSymbol)()())(numDownloadStreamsIsSymbol)()())(iconSourceIsSymbol)()())(iconDestinationIsSymbol)()())(engineTypeIsSymbol)()())(destinationsIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons15(Data_Argonaut_Decode_Class.gDecodeJsonNil)(uploadIsSymbol)()())(speedtestRouteIsSymbol)()())(prepareIsSymbol)()())(pingIsSymbol)()())(errorIsSymbol)()())(downloadIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons4(speedtestStartedIsSymbol)()())(speedtestResultIsSymbol)()())(scrollModeIsSymbol)()())(pageSettingsIsSymbol)()())(pageMeasureResultIsSymbol)()())(pageDashboardIsSymbol)()())(pageIsSymbol)()())(consentIsSymbol)()())(commonQueryIsSymbol)()())(brandIsSymbol)()())(appModeIsSymbol)()())(afterConsentIsSymbol)()())());
var decodeJsonAppStateJ = {
    decodeJson: function (json) {
        return bind(decodeJson1(json))(function (v) {
            return bind(decodeJson(json))(function (v1) {
                return pure(merge(v)({
                    appSize: unwrap(v1.appSize)
                }));
            });
        });
    }
};
var selectMaxUploadBookedSpeed = function (state) {
    return bind1(state.speedtestResult.prepare)(function (v) {
        return v.info.contractInfo.maxUploadBookedSpeed;
    });
};
var selectMaxDownloadBookedSpeed = function (state) {
    return bind1(state.speedtestResult.prepare)(function (v) {
        return v.info.contractInfo.maxDownloadBookedSpeed;
    });
};
var resultsAvailable = function (msmt) {
    return function (v) {
        if (msmt instanceof Fusion_Data_Measurement.Download) {
            return notEq(v.speedtestResult.download.intermediates.totalSpeed)([  ]);
        };
        if (msmt instanceof Fusion_Data_Measurement.Upload) {
            return notEq(v.speedtestResult.upload.intermediates.totalSpeed)([  ]);
        };
        if (msmt instanceof Fusion_Data_Measurement.Ping) {
            return notEq1(v.speedtestResult.ping.intermediates)([  ]);
        };
        throw new Error("Failed pattern match at Visonum.Cross.Components.App.Types.AppState (line 388, column 3 - line 391, column 53): " + [ msmt.constructor.name ]);
    };
};
var isEmptySpeedtestRouteFields = function (cfg) {
    return and([ cfg.fieldEngineUrl === "", cfg.fieldDestinationUrls === "" ]);
};
var initialPingResult = /* #__PURE__ */ (function () {
    return {
        intermediates: [  ],
        "final": Data_Maybe.Nothing.value,
        running: false
    };
})();
var initialLoadResult = /* #__PURE__ */ (function () {
    return {
        intermediates: {
            totalSpeed: [  ],
            streamSpeeds: Data_Map_Internal.empty
        },
        statIntermediatesActive: [  ],
        statIntermediatesPassive: [  ],
        current: Data_Maybe.Nothing.value,
        "final": Data_Maybe.Nothing.value,
        running: false,
        warnings: [  ]
    };
})();
var initialSpeedtestResults = /* #__PURE__ */ (function () {
    return {
        prepare: Data_Maybe.Nothing.value,
        download: initialLoadResult,
        upload: initialLoadResult,
        ping: initialPingResult,
        error: Data_Maybe.Nothing.value,
        speedtestRoute: Data_Maybe.Nothing.value
    };
})();
var initialState = function (v) {
    return {
        page: Visonum_Cross_Components_App_Types_Page.PageDashboard.value,
        brand: v.brand,
        speedtestResult: initialSpeedtestResults,
        speedtestStarted: Data_Maybe.Nothing.value,
        scrollMode: AutoScroll.value,
        appSize: zero,
        appMode: ExpertMode.value,
        commonQuery: v.commonQuery,
        pageDashboard: {
            rapidPingResult: Data_Maybe.Nothing.value,
            selectedSpeedtestRouteIndex: 0
        },
        pageMeasureResult: {
            selectedTab: Fusion_Data_Measurement.Download.value,
            showWarnings: false
        },
        pageSettings: {
            speedtestRoutes: Data_Array_NonEmpty["cons$prime"]({
                title: "Device Server",
                iconSource: "/static-assets/phone.svg",
                iconDestination: "/static-assets/globe.svg",
                fieldEngineUrl: "",
                fieldStreamCountDownload: 5,
                fieldStreamCountUpload: 2,
                useLocalEngine: true,
                fieldDestinationUrls: MST_Data_BasicURL.printMany(v.destinationUrls),
                checkResult: Data_Maybe.Nothing.value
            })([ {
                title: "",
                iconSource: "",
                iconDestination: "",
                fieldEngineUrl: "",
                fieldStreamCountDownload: 5,
                fieldStreamCountUpload: 2,
                useLocalEngine: false,
                fieldDestinationUrls: "",
                checkResult: Data_Maybe.Nothing.value
            }, {
                title: "",
                iconSource: "",
                iconDestination: "",
                fieldEngineUrl: "",
                fieldStreamCountDownload: 5,
                fieldStreamCountUpload: 2,
                useLocalEngine: true,
                fieldDestinationUrls: "",
                checkResult: Data_Maybe.Nothing.value
            } ])
        },
        consent: Visonum_Cross_Types_UserConsent.initUserConsent,
        afterConsent: AfterConsentSpeedtest.value
    };
};
var initInternalState = function (v) {
    return {
        speedtestSubscriptionId: Data_Maybe.Nothing.value,
        speedtestFiber: Data_Maybe.Nothing.value,
        embedOpts: v.embedOpts
    };
};
var initFullAppState = function (cfg) {
    return {
        app: initialState(cfg),
        internal: initInternalState(cfg)
    };
};
var getTotalPoints = function (loadResult) {
    var extraPoints = Data_Maybe.maybe([  ])(pure1)(mapFlipped(loadResult.current)(function (v) {
        return v.totalSpeed;
    }));
    return append(loadResult.intermediates.totalSpeed)(extraPoints);
};
var getSpeedtestRoutes = function (speedtestRoutes) {
    return Data_Array.filter(not(isEmptySpeedtestRouteFields))(Data_Array_NonEmpty.toArray(speedtestRoutes));
};
var showRouteSelect = function (state) {
    return Data_Array.length(getSpeedtestRoutes(state.pageSettings.speedtestRoutes)) > 1;
};
var getSpeedtestRouteFromFields = function (cfg) {
    return apply(map(function (v) {
        return function (v1) {
            var iconSource = (function () {
                var $1400 = cfg.iconSource === "";
                if ($1400) {
                    return "/static-assets/phone.svg";
                };
                return cfg.iconSource;
            })();
            var iconDestination = (function () {
                var $1401 = cfg.iconDestination === "";
                if ($1401) {
                    return "/static-assets/globe.svg";
                };
                return cfg.iconDestination;
            })();
            return {
                engineType: v,
                destinations: v1,
                title: cfg.title,
                numDownloadStreams: cfg.fieldStreamCountDownload,
                numUploadStreams: cfg.fieldStreamCountUpload,
                iconSource: iconSource,
                iconDestination: iconDestination
            };
        };
    })((function () {
        if (cfg.useLocalEngine) {
            return pure2(MST_Data_EngineCommunication.Local.value);
        };
        return map(function (url) {
            return new MST_Data_EngineCommunication.Remote({
                url: url
            });
        })(Data_Either.hush(MST_Data_BasicURL.parse(cfg.fieldEngineUrl)));
    })()))(MST_Data_BasicURL.parseMany(cfg.fieldDestinationUrls));
};
var getSelectedSpeedtestRoute = function (v) {
    var routes = getSpeedtestRoutes(v.pageSettings.speedtestRoutes);
    return bind1(Data_Array.index(routes)(mod(v.pageDashboard.selectedSpeedtestRouteIndex)(Data_Array.length(routes))))(function (speedtestRouteFields) {
        return getSpeedtestRouteFromFields(speedtestRouteFields);
    });
};
var getPerStreamPoints = function (loadResult) {
    var currentPoints = Data_Maybe.fromMaybe([  ])(mapFlipped(loadResult.current)(function (v) {
        return v.streamSpeeds;
    }));
    return map1(function (v) {
        return append(v.value1)(Data_Maybe.fromMaybe([  ])(bind1(Data_Array.index(currentPoints)(v.value0))(function (point) {
            return bind1(loadResult.current)(function (cur) {
                return pure2([ {
                    speed: point.speed,
                    timestamp: cur.totalSpeed.timestamp
                } ]);
            });
        })));
    })(toUnfoldable(loadResult.intermediates.streamSpeeds));
};
var getDuration = function (loadResult) {
    var totalPoints = getTotalPoints(loadResult);
    return bind1(minimum(map1(function (v) {
        return v.timestamp;
    })(totalPoints)))(function (minTime) {
        return bind1(maximum(map1(function (v) {
            return v.timestamp;
        })(totalPoints)))(function (maxTime) {
            return pure2(Fusion_Data_Timestamp.diff(maxTime)(minTime));
        });
    });
};
var anyResultsAvailable = /* #__PURE__ */ (function () {
    return disj(resultsAvailable(Fusion_Data_Measurement.Download.value))(disj(resultsAvailable(Fusion_Data_Measurement.Upload.value))(resultsAvailable(Fusion_Data_Measurement.Ping.value)));
})();
var _internal = function (dictStrong) {
    return prop(dictStrong);
};
var _app = function (dictStrong) {
    return prop1(dictStrong);
};
export {
    ExpertMode,
    NormalMode,
    AppStateJ,
    AutoScroll,
    ManualScroll,
    getDuration,
    getPerStreamPoints,
    getTotalPoints,
    initialSpeedtestResults,
    initialLoadResult,
    initialState,
    showRouteSelect,
    selectMaxDownloadBookedSpeed,
    selectMaxUploadBookedSpeed,
    _app,
    _internal,
    initFullAppState,
    resultsAvailable,
    anyResultsAvailable,
    AfterConsentSpeedtest,
    AfterConsentSettings,
    getSpeedtestRouteFromFields,
    getSelectedSpeedtestRoute,
    getSpeedtestRoutes,
    genericAppMode_,
    encodeJsonAppMode,
    decodeJsonAppMode,
    showAppMode,
    eqAppMode,
    genericScrollMode_,
    showScrollMode,
    newtypeAppStateJ_,
    encodeJsonAppStateJ,
    encodeJsonScrollMode,
    decodeJsonScrollMode,
    decodeJsonAppStateJ,
    eqAfterConsent,
    genericAfterConsent_,
    showAfterConsent,
    encodeJsonAfterConsent,
    decodeJsonAfterConsent
};
